import StoreAddress from '@components/storelocator/StoreAddress';
import DwFormField from '@ui/formfield/DwFormField';
import RadioGroup from '@ui/radioGroup/RadioGroup';
import RadioGroupItem from '@ui/radioGroup/RadioGroupItem';
import api from '@utils/api';
import { BAA } from '@utils/constants';
import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import Tooltip from '@ui/tooltip/Tooltip';
const BookAnAppointmentStoreSelector = (props) => {
    var _a;
    const { t } = useTranslation();
    const [reasonSelect, setReasonSelect] = useState();
    const [countrySelect, setCountrySelect] = useState();
    const [citySelect, setCitySelect] = useState();
    const [storesByCity, setStoresByCity] = useState([]);
    const [mapZoom, setMapZoom] = useState(10);
    const [mapCenter, setMapCenter] = useState();
    const [stores, setStores] = useState([]);
    const [storeFilter, setStoreFilter] = useState([]);
    const [storesSlotType, setStoresSlotType] = useState([]);
    const [countries, setCountries] = useState([]);
    const [loadingCities, setLoadingCities] = useState(true);
    const mapEl = useRef();
    const cities = useMemo(() => {
        const storesFilterArray = stores.filter((store) => storeFilter.includes(store.ID));
        return [...new Set(storesFilterArray.map((store) => store.city))];
    }, [stores, storeFilter]);
    const filterStore = () => {
        return stores.filter((store) => storeFilter.includes(store.ID));
    };
    useEffect(() => {
        props.resetFields;
    }, [props.resetFields]);
    useEffect(() => {
        let personalizationReason = Number(props.initialValues.reason) == BAA.REASONS.PERSONALIZATION;
        updateCountries(personalizationReason);
        // if (!personalizationReason) {
        //   onSelectReason(props.initialValues.reason);
        // }
    }, []);
    useEffect(() => {
        if (!props.liveBoutique && props.store) {
            setMapCenter(new google.maps.LatLng(props.store.latitude, props.store.longitude));
            setMapZoom(18);
        }
    }, [props.store]);
    useEffect(() => {
        if (stores.length > 0 && citySelect) {
            let storeFiltered = filterStore();
            setStoresByCity(storeFiltered.filter((store) => {
                return store.city === citySelect;
            }));
            // on city change
            selectStore(stores.filter((filteredStore) => filteredStore.city === citySelect && (storeFilter === null || storeFilter === void 0 ? void 0 : storeFilter.includes(filteredStore === null || filteredStore === void 0 ? void 0 : filteredStore.ID)))[0]);
            props.mutator({ storeid: stores.filter((store) => store.city === citySelect)[0] });
        }
    }, [citySelect, stores, storeFilter]);
    const storeFilterArray = (country, personalizationReason, reasonSelect) => {
        api.bookAnAppointmentStores(country, personalizationReason ? '861860000' : '', props.appointmentType, reasonSelect).then((data) => {
            let arr = [...storeFilter];
            arr = data.stores.map((e) => e.code);
            setStoreFilter(arr);
            setStoresSlotType(data.stores);
        });
        return storeFilter;
    };
    const updateStores = async (country, personalizationReason) => {
        setLoadingCities(true);
        if (props.liveBoutique) {
            api.getLiveBoutiqueStoresForAppointment(country).then((data) => {
                var _a;
                setStores(data.Store);
                if (props.initialValues.citySelect) {
                    const initialCity = (_a = stores.find((el) => el.city == props.initialValues.citySelect)) === null || _a === void 0 ? void 0 : _a.city;
                    if (initialCity)
                        setCitySelect(initialCity);
                }
            }).finally(() => {
                setLoadingCities(false);
            });
        }
        else {
            api.getStoresForAppointment(country).then((data) => {
                var _a;
                setStores(data.Store);
                if (props.initialValues.citySelect) {
                    const initialCity = (_a = stores.find((el) => el.city == props.initialValues.citySelect)) === null || _a === void 0 ? void 0 : _a.city;
                    if (initialCity)
                        setCitySelect(initialCity);
                }
            }).finally(() => {
                setLoadingCities(false);
            });
        }
    };
    const updateCountries = async (personalizationReason, reasonValue) => {
        api.getCountriesWithBAA(personalizationReason, props.liveBoutique ? true : false).then((data) => {
            setCountries(data);
            let selectedCountry = data.find((el) => el.selected);
            if (props.initialValues.countrySelect) {
                selectedCountry = data.find((el) => el.value == props.initialValues.countrySelect);
            }
            if (selectedCountry) {
                setCountrySelect(selectedCountry.value);
                props.mutator({ countrySelect: selectedCountry.value });
                storeFilterArray(countrySelect, personalizationReason, reasonValue);
                updateStores(selectedCountry.value, personalizationReason);
            }
            else {
                // mostro il messaggio che non ci sono store con BAA per la country corrente
            }
        });
    };
    const selectStore = (store) => {
        var _a;
        let availableSlotsTypes;
        let availableSlotTypes;
        if (store) {
            let storeSlotType = storesSlotType === null || storesSlotType === void 0 ? void 0 : storesSlotType.filter((e) => (e === null || e === void 0 ? void 0 : e.code) == store.ID);
            availableSlotsTypes = (_a = storeSlotType[0]) === null || _a === void 0 ? void 0 : _a.availableSlotTypes;
            if ((availableSlotsTypes === null || availableSlotsTypes === void 0 ? void 0 : availableSlotsTypes.length) > 1 && (availableSlotsTypes === null || availableSlotsTypes === void 0 ? void 0 : availableSlotsTypes.includes(BAA.APPOINTMENT.CARAVAN))) {
                availableSlotTypes = BAA.APPOINTMENT.CARAVAN;
            }
            else {
                availableSlotTypes = availableSlotsTypes[0];
            }
        }
        props.setAvailableSlotTypes && props.setAvailableSlotTypes(availableSlotTypes);
        props.onSelect && props.onSelect(store);
    };
    const onSelectCity = (city) => {
        setCitySelect(city);
        selectStore(null);
    };
    const onSelectReason = (reasonValue) => {
        props.mutator({ countrySelect: undefined, citySelect: undefined, storeid: undefined });
        setCitySelect(null);
        selectStore(null);
        setReasonSelect(reasonValue);
        props.setReasonSelect(reasonValue);
        let personalizationReason = reasonValue == BAA.REASONS.PERSONALIZATION;
        updateCountries(personalizationReason, reasonValue);
        storeFilterArray(countrySelect, personalizationReason, reasonValue);
        updateStores(countrySelect, personalizationReason);
    };
    const onSelectCountry = (country) => {
        let personalizationReason = reasonSelect == BAA.REASONS.PERSONALIZATION;
        if (country != countrySelect) {
            if (props.liveBoutique) {
                setStoresByCity([]);
            }
            setCountrySelect(country);
            storeFilterArray(country, personalizationReason, reasonSelect);
            updateStores(country, personalizationReason);
            setCitySelect(null);
            selectStore(null);
            props.mutator({ citySelect: undefined, storeid: undefined });
        }
    };
    const pickupStores = (virtualAppointment) => {
        return (React.createElement("div", { className: classNames('storelist', { 'overflow-visible': virtualAppointment }) },
            React.createElement(RadioGroup, { id: "storelist", setSelected: (id) => {
                    const store = storesByCity.find((store) => {
                        return store.ID == id;
                    });
                    selectStore(store);
                } }, storesByCity.map((store, index) => {
                var _a, _b;
                return (React.createElement(RadioGroupItem, { inputCentered: virtualAppointment, content: React.createElement("div", { className: classNames('optionbox__item__content', { 'optionbox__item__content--no-outline': !virtualAppointment }, 'optionbox__item__content--bordered', {
                            selected: store.ID === ((_a = props.store) === null || _a === void 0 ? void 0 : _a.ID),
                        }) },
                        React.createElement("div", { className: classNames('option-store', { 'option-store__virtual': virtualAppointment }) },
                            React.createElement("div", null,
                                virtualAppointment && store.liveBoutique && (React.createElement("div", { className: "option-store__live-boutique" },
                                    React.createElement("span", { className: "primary-xxs" }, t('bookanappointment.liveboutique')),
                                    !props.liveBoutique && (React.createElement(Tooltip, { ariaLabel: t('label.info'), checkout: true, id: `${store.ID}-live-boutique-info`, icon: "info", className: "live-boutique-info", text: t('bookanappointment.liveboutiquetoltip', { 0: window.liveBoutiqueUrl }) })))),
                                React.createElement("span", { className: "option-store__title" }, store.name),
                                React.createElement("div", { className: "option-store__address" },
                                    React.createElement(StoreAddress, { store: store, hidename: true }))))), key: store.ID, id: store.ID, selected: store.ID === ((_b = props.store) === null || _b === void 0 ? void 0 : _b.ID) }));
            }))));
    };
    const noStoresMessage = useCallback(() => {
        return (countries === null || countries === void 0 ? void 0 : countries.length) > 0 && !countries.find((el) => el.selected) ? (React.createElement("div", { className: "row mb-24" },
            React.createElement("div", { className: "col-12" },
                React.createElement("p", null, t('bookanappointment.nostoresincurrentlocation', { country: window.countryname }))))) : (React.createElement(React.Fragment, null));
    }, [countries]);
    return (React.createElement("div", { className: "checkout-pickup bookanappointment-wrapper" },
        noStoresMessage(),
        React.createElement("div", { className: "row" },
            !props.liveBoutique && (React.createElement("div", { className: "col-12 " },
                React.createElement(DwFormField, { def: props.formdef, name: "reason", type: "select", onChange: (e) => onSelectReason(Number(e.target.value)), options: props.appointmentType != BAA.APPOINTMENT.VIRTUAL
                        ? props.formdef.reason.options
                        : props.formdef.reason.options.filter((o) => o.value != BAA.REASONS.PERSONALIZATION) }))),
            React.createElement("div", { className: "col-sm-6" },
                React.createElement(DwFormField, { def: props.formdef, name: "countrySelect", type: "select", disabled: (!reasonSelect && !props.liveBoutique) || loadingCities, onChange: (e) => onSelectCountry(e.target.value), options: [
                        ...[
                            {
                                value: '',
                                selected: false,
                                label: t('checkout.picking.selectcountry'),
                                disabled: true,
                            },
                        ],
                        ...(_a = countries
                            .map((country, i) => {
                            return {
                                value: country.value,
                                selected: country.value === countrySelect,
                                label: t(`baa.${country.label.replaceAll(/\s|,/g, '').toLowerCase()}`),
                            };
                        })) === null || _a === void 0 ? void 0 : _a.sort((a, b) => {
                            if (a.label && b.label) {
                                const A = a.label.toUpperCase();
                                const B = b.label.toUpperCase();
                                return A.localeCompare(B);
                            }
                        }),
                    ] })),
            React.createElement("div", { className: "col-sm-6" },
                React.createElement(DwFormField, { def: props.formdef, disabled: loadingCities || (!reasonSelect && !props.liveBoutique) || !countrySelect, name: "citySelect", type: "select", onChange: (e) => onSelectCity(e.target.value), options: [
                        ...[
                            {
                                value: '',
                                selected: false,
                                label: t('checkout.picking.selectcity'),
                            },
                        ],
                        ...cities.map((city, i) => {
                            return {
                                value: city,
                                selected: city === citySelect,
                                label: city,
                            };
                        }),
                    ] }))),
        !props.showmap ? (React.createElement("div", { className: "row" },
            React.createElement("div", { className: "col-12 overflow-visible" },
                stores.length > 0 && citySelect && props.liveBoutique && (React.createElement("div", { className: "row" },
                    React.createElement("p", { className: "disclaimer mt-20 mb-32" }, t('liveboutique.disclaimer')))),
                !props.resetFields && pickupStores(true)))) : ((stores === null || stores === void 0 ? void 0 : stores.length) > 0 &&
            citySelect && (React.createElement("div", { className: "row map-row" },
            React.createElement("div", { className: "col-12 mt-12 overflow-visible" }, !props.resetFields && pickupStores(props.appointmentType == BAA.APPOINTMENT.VIRTUAL))))),
        loadingCities && (reasonSelect || props.liveBoutique) && (React.createElement("div", { className: "appointments-loading-screen__form" },
            React.createElement("div", null,
                (props.loaderSrc || window.loaderSrc) && React.createElement("img", { src: props.loaderSrc || window.loaderSrc, alt: "loading" }),
                React.createElement("h4", null, t('appointments.formloading', 'Just a few moments')))))));
};
export default BookAnAppointmentStoreSelector;
